import { createGlobalStyle } from 'styled-components';

import SourceSansProBold from '@/assets/fonts/source-sans-pro-bold.woff';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'SourceSansProBold';
    src: url(${SourceSansProBold});
    font-weight: bold;
    font-style: normal;
  }
  
  .generated-images-holder-var20 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var20 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .text-var20 {
    position: absolute;
    width: 100%;
    padding: 0 20px;
    bottom: 38px;
    font-size: 55px;
    line-height: 1.2;
    text-align: center;
    color: #fff;
    font-family: SourceSansProBold;
    p {
      border: solid 12px white;
      background-color: rgba(0,0,0,0.4);
      display: inline-block;
      margin: 0;
      padding: 8px 33px 9px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }
  .text-var20--top {
    bottom: auto;
    top: 38px;
  }
  .actual-photo-var20 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var20--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
